import PlataformApi from "@/services/plataformApi"

const Conteudo = {
  components: {
    PlataformApi,
  },
  state: {
    categorias: []
  },
  getters: {
    categorias: state => {
      return state.categorias
    }
  },
  mutations: {
    setCategorias (state, categorias) {
      state.categorias = categorias
    }
  },
  actions: {
    async getCategorias({ commit }) {
      let categorias = await PlataformApi.listarCategorias()
      commit('setCategorias', categorias.categorias)
    }
  }
};

export default Conteudo;